import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';

import account from './images/account.jpg'; 
import agpranges from './images/agpranges.jpg';  
import agpprofiles from './images/agpprofiles.jpg';
//import bolusdetails from './images/bolusdetails.jpg';  
import daysgraph from './images/daysgraph.jpg';  
import daysdetails from './images/daysdetails.jpg';   
import datasources from './images/datasources.jpg';  
import notifications from './images/notifications.jpg'; 
import settings from './images/settings.jpg';  
import sharing from './images/sharing.jpg'; 
import statistic from './images/statistic.jpg';

function HelpGuidance() {
  return (
    <main id="helpGuidance" className="textPage">
      <h1>Ohjeet - Sensotrend Dashboard</h1>
      <ul className="toc">
        <li><Link to="/help">Etusivulle</Link></li>
        <br />         
        <li><Link to="/helpIntro">Palvelun esittely</Link></li> 
        <li><big><b>Käyttöohjeet</b></big></li>
        <li><Link to="/helpTips">Tiedon hyödyntäminen</Link></li>
        <br /> 
        <li><Link to="/helpForPractitioner">Ammattilaisille</Link></li>
      </ul>
      <h1>Käyttöohjeet</h1>
      <p>Lukuaika noin 7 min.</p> 
      <ul>
        <li><Link to="#agp">AGP-raportti</Link></li>
        {/*              
        <li><Link to="#insulin">Insuliini</Link></li>
        <li><Link to="#nutrition">Ravinto</Link></li>
        <li><Link to="#exercise">Liikunta</Link></li>
        <li><Link to="#diary">Päiväkirja</Link></li>
        */}
        <li><Link to="#day">Päivänäkymä</Link></li>
        <li><Link to="#settings">Ilmoitukset ja asetukset</Link></li>
      </ul>
      <section id="agp">
        <h2>AGP-raportti</h2>
        <p>
          <Link to="#top">Takaisin alkuun</Link>
        </p>
        <p>
          AGP-näkymän oikeassa yläkulmassa on "Aika glukoosialueilla" -kaavio. Kun hiiren kursorin
          vie tämän kaavion päälle, tulee näkyviin hoitotasapainoa kuvaavat tunnusluvut sisältävä
          ponnahdusikkuna. Hiiren vasen painiketta painettaessa tunnusluvun kopioituvat
          leikepöydälle, mistä ne on helppo liittää haluamaasi dokumenttiin tai vaikkapa
          lähetettäväksi sinua hoitavalle terveydenhuollon ammattilaiselle sähköpostitse.
        </p>
        <p>
          <img src={statistic} alt="Tunnusluvut" />
        </p>
        <p>
          Glukoosiprofiilissa on oletuksena asetettu glukoosiarvojen tavoitealueeksi 3,9-10,0
          mmol/l. Tavoitealueatta pystyy muuttamaan kuvaajan vasemmassa reunassa olevista luvuista,
          jotka kertovat tavoitealueen ala- ja ylärajan. Tavoiterajoja voi joko raahata hiiren
          kursorilla tai luvut voi kirjoittaa kuvaajassa oleviin kenttiin. Tavoitearvoja
          muutettaessa AGP-raportin oikeassa  yläkulmassa oleva "Aika glukoosialueella" -alue
          lasketaan uudelleen. 
        </p>
        <p>
          Myös kuvaajassa vaaleansinisellä esitetyn 90 % tarkastelualueen pystyy muuttamaan 80 %
          tarkastelualueeksi. Tämä tapahtuu napauttamalla kuvaajan oikeassa laidassa olevia
          prosenttilukuja, jotka ovat oletuksena 95 % ja 5 %. Toiminnallisuuden tarkoitus on auttaa
          löytämään niitä vuorokaudenaikoja, jolloin merkittävä osa mittaustuloksista on
          tavoitealueen ulkopuolella. 
        </p>
        <p>
          Alla olevassa esimerkissä glukoosiarvojentavoitealueeksi on asetettu 4,4-9,5 mmol/l.
          Lisäksi vaaleansininen alue on muutettu 80 % tarkastelualueeksi.
        </p>
        <p>
          <img src={agpranges} alt="Kuvaajan säätömahdollisuuksia" />
        </p>
        <p>
          AGP-raportin oletusarvoinen tarkastelujakso on kaksi viikkoa. Tätä aikaa pystyy
          muuttamaan AGP-rapostin alaosassa olevan "Päivittäiset glukoosiprofiilit" -alueen
          otsikkokentässä olevia päivämääriä muuttamalla. Päivämäärän muuttaminen onnistuu joko
          kirjoittamalla päivämäärät kenttiin tai valitsemalla ne kalenterinäkymästä. Päivämäärien
          muuttamisen jälkeen AGP-raportti asketaan uudelleen.
        </p>
        <p>
          Tarkastelujaksolla olevia päiviä voi myös suodattaa pois joko klikkaamalla viikonpäivien
          nimiä tai pienten kuvien alla olevia päivämääriä. Myös tämän muutoksen jälkeen
          AGP-raportti lasketaan uudelleen. 
        </p>
        <p>
          Alla olevassa esimerkissä tarkastelujakso on muutettu kahdesta viikosta neljään viikkoon.
          Tämän lisäksi tarkastelujaksosta on suodatettu pois lauantait ja sunnuntait, jotta on
          päästy näkemään pelkkiä arkipäiviä kuvaava AGP-raportti. Raportista on vielä suodatettu
          pois 6.5.2019, jonka lukemat ovat olleet tavallisuudesta poikkeavat esimerkiksi sairauden
          tai sensorin vaihdon vuoksi. 
        </p>
        <p>
          <img src={agpprofiles} alt="Tarkasteluajan muokkausmahdollisuuksia" />
        </p>
      </section>
      {/*
      <section id="insulin">
        <h2>Insuliini</h2>
        <p>
          <Link to="#top">Takaisin alkuun</Link>
        </p>
        <p>
          Boluskuvaaja sisältää yksityiskohtaista tietoa kyseisen tunnin bolusannostelusta
          tarkastelujakson aikana. Yksityiskohdista saa lisää tietoa viemällä hiiren kursorin
          kyseisen yksityiskohdan päälle. Tässä esimerkissä tarkastelujakson aikana on kyseisellä
          tunnilla annosteltu bolusinsuliinia 6 kertaa (luku ympyrässä), 80 % insuliiniannoksista
          on ollut välillä 1,4-7,8 ky (kapea sininen viiva), 50 % insuliiniannoksista on ollut
          välillä 2,3-6,3 ky (leveämpi sininen palkki) ja bolusinsuliinin mediaaniannos on ollut
          5,35 ky (musta ympyrä).
        </p>
        <img src={bolusdetails} alt="Bolusdiagrammin yksityiskohtia" />
      </section>
      <section id="nutrition">
        <h3>Ravinto</h3>
        <p>
          <Link to="#top">Takaisin alkuun</Link>
        </p>
      </section>
      <section id="exercise">
        <h3>Liikunta</h3>
        <p>
          <Link to="#top">Takaisin alkuun</Link>
        </p>
      </section>
      <section id="diary">
        <h3>Päiväkirja</h3>
        <p>
          <Link to="#top">Takaisin alkuun</Link>
        </p>
      </section> 
      */}
      <section id="day">
        <h2>Päivänäkymä</h2>
        <p>
          <Link to="#top">Takaisin alkuun</Link>
        </p>
        <p>
          Päivänäkymän yksityiskohdistaa saa lisää tietoa viemällä hiiren osoittimen yksityiskohdan
          päälle tai klikkaamalla yksityiskohtaa kosketusnäytöltä. Kuvaajassa on esitetty
          glukoosiarvojen vaihtelu päivän aikana. Samalla kuvaajalla on sekä sensoroinnin tuottamat
          lukemat (pienet mustat pisteet) että sormenpäämittaukset (punaiset ympyrät). Tarkan
          lukeman pääsee näkemään pisteen kohdalta, kuten alla olevassa esimerkissä on tehty. 
        </p>
        <p>
          <img src={daysgraph} alt="Päivänäkymän grafiikka" />
        </p>
        <p>
          Kuvaajan alla on esitetty lisätietoja päivän ajalta. Tiedot ovat ajallisesti samalla
          kohdalla yläpuolella olevan kuvaajan merkintöjen kanssa. Tietojen määrä riippuu
          käytössäsi olevista laitteista ja tietolähteistä. Myös tällä alueella olevista tiedosta
          pääsee näkemään yksityiskohtia viemällä hiiren osoittimen tiedon päälle tai klikkaamalla
          yksityiskohtaa kosketusnäytöltä. Jos atriakuvia on käytettävissä, ne aukeavat isommiksi 
          kuvaa klikkaamalla alla olevan esimerkin tapaan.
        </p>
        <p>
          Tietolähteiden lisäämisestä kerrotaan tarkemmin kohdassa <Link
          to="/helpTips#images">Ateriakuvien vieminen palveluun</Link>.
        </p>
        <p>
          <img src={daysdetails} alt="Päivänäkymän yksityiskohtia" />
        </p>
      </section>
      <section id="settings">
        <h2>Ilmoitukset ja asetukset</h2>
        <p>
          <Link to="#top">Takaisin alkuun</Link> 
        </p>
        <p>
          Sensotrend Dashboardin näkymien yläosassa on pieni kellon kuva ilmoitusten merkkinä. Kellon viereen ilmestyy
          ympyröity numero tilitoimia vaativan ilmoituksen merkiksi. Ilmoitukset aukeavat kellon kuvaa klikkaamalla. 
          Tarvittavan tilitoimen mahdollistava sivu aukeaa ilmoituksen tekstiä klikkaamalla.
        </p>
        <p>
          <img src={notifications} alt="Ilmoitukset" />
        </p>
        <p>
          Asetukset-valikko aukeaa sivun oikeassa yläkulmassa näkyvää nimeäsi klikkaamalla.
        </p>
        <p>
          <img src={settings} alt="Asetukset" />
        </p>
        <p>
          Profiili-asetuksista voit muuttaa käyttäjätilisi asetuksia, käyttöliittymän kieltä ja käytettävää glukoosiarvojen 
          mittayksikkö sekä lopettaa käyttäjätilisi.
        </p>
        <p>
          <img src={account} alt="Profiili-asetuksen" />
        </p>
        <p>
          'Tietolähteet'-sivulta pääset hallinnoimaan kättettäviä tietolähteitä. Tärkeintä tällä sivulla on se, että 
          Kanta-yhteys on kunnossa ja sen merkkinä liitetyn käyttäjän tunnisteena toimiva numerosarja on näkyvissä
          Kanta-yhteyden kohdalla. 
        </p>
        <p>
          Hyvinvointitietoja tarjoavien tietolähteiden liittämisestä kerrotaan 
          tarkemmin <Link to="/helpTips">Tiedon hyödyntäminen</Link>-sivulla.
        </p>
        <p>
          <img src={datasources} alt="Tietolähteet" />
        </p>
        <p>
          'Tietojen jakaminen' -sivulla pystyt hallinnoimaan tietojesi jakamisasetuksia. Yleisistä jakamisasetuksista 
          voit asettaa jakamisasetukset käyttökohteiden tasolla, mikä mahdollistaa tiedon sujuvan jakamisen juuri 
          niille tahoille, joille tietojasi haluat luovuttaa. Vastaavasti pystyt kieltämään tietojen jakamisen
          niille toimijoille, joille et halua tietojasi jakaa. Meille on tärkeää, että sinä itse saat päättää
          tietojesi käyttökohteet ja hallinnoida tietojen jakamista itsenäisesti! 
        </p>
        <p>
          Kohdassa 'Luvat tietojesi katseluun' löytyvät ne terveydenhuollon yksiköt, jotka ovat pyytäneet lupaa
          tietojesi katseluun. Tässä kohdassa voit sallia ja kieltää tietojesi katselun aina halutessasi. Huomaathan 
          kuitenkin, että tietosi eivät ole käytettävissä vastaanottokäynnillä, jos tietojen katselulupa ei ole aktiivisena.
        </p>
        <p>
          Kohdassa 'Käsiteltävät tietot' on esitetty yhteenveto terveystiedostasi, joihin Sensotrend Dashboardilla on pääsy.
          Nämä tiedot on mahdollista ladata json-muodossa muissa soveluksissa käytettäväksi.
        </p>
        <p>
          <img src={sharing} alt="Tietojen jakaminen" />
        </p>
      </section>
      <footer>
        {/* The date is for MDR, annex I, clause 23.4, subclause y).
            Date format is specified in ISO 1041:2008 & A1:2013, clause 4.4.
        */}
        <small>2021-06-11</small>
      </footer>
    </main>
  );
}

export default HelpGuidance;